// extracted by mini-css-extract-plugin
export var entityChip = "_t3-0";
export var entityChipMissing = "_t3-1";